import { createSelector } from 'reselect';

import { AppState } from '../../../../../../store/models/app-state';
import { isImageFile } from '../../../../../../common/models/product-file';

const productDetailFilesState = (state: AppState) => state.product.detail.files;

export const imageFilesSelector = createSelector(productDetailFilesState, state => state.files.filter(isImageFile));
export const otherFilesSelector = createSelector(productDetailFilesState, state =>
    state.files.filter(file => !isImageFile(file))
);
export const overallUploadProgressSelector = createSelector(
    [imageFilesSelector, otherFilesSelector],
    (images, others) => {
        const progress = [...images, ...others]
            .map(file => file.uploadProgress)
            // Filter undefined elements with a type guard to make Typescript understand what I want
            .filter((uploadProgress): uploadProgress is number => !!uploadProgress);

        if (progress.length === 0) {
            return 0;
        }

        const sum = progress.reduce((result, item) => {
            return result + item;
        }, 0);
        return sum / progress.length;
    }
);
